import React from "react";
import BaseListPage from "../../base/BaseListPage";
import {
  findObjectUseCase,
  updateObjectUseCase,
  countObjectUseCase,
  deleteObjectUseCase,
} from "../../usecases/object";
import NotificationListPagePresenter from "./NotificationListPagePresenter";
import TabbedCard from "../../components/TabbedCard";
import { normalizeNotification, getTabsWithCounts } from "./utils";
import {
  NotificationList,
  NotificationListEmpty,
  NotificationListLoading,
} from "./components";
import withRouter from "../../withRouter";

class NotificationListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = { ...this.state, selectedIds: [] };
    this.presenter = new NotificationListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      updateObjectUseCase(),
    );
    this.toggleSelect = this.toggleSelect.bind(this);
    this.selectAllForList = this.selectAllForList.bind(this);
    this.bulkMarkRead = this.bulkMarkRead.bind(this);
    this.bulkMarkUnread = this.bulkMarkUnread.bind(this);
    this.bulkDelete = this.bulkDelete.bind(this);
    this.onClickNotification = this.onClickNotification.bind(this);
    this.onMenuAction = this.onMenuAction.bind(this);
  }

  getCollectionName() {
    return "notifications";
  }

  getSelectedIds() {
    return this.state.selectedIds || [];
  }

  setSelectedIds(ids) {
    this.setState({ selectedIds: ids || [] });
  }

  setNotificationRead(notif, isRead) {
    this.presenter.setNotificationRead(notif, isRead);
  }

  setNotificationsRead(ids, isRead) {
    this.presenter.setNotificationsRead(ids, isRead);
  }

  removeNotifications(ids) {
    this.presenter.removeNotifications(ids);
  }

  bulkMarkRead() {
    this.presenter.bulkMarkRead();
  }

  bulkMarkUnread() {
    this.presenter.bulkMarkUnread();
  }

  bulkDelete() {
    this.presenter.bulkDelete();
  }

  toggleSelect(notif) {
    this.presenter.toggleSelect(notif);
  }

  selectAllForList(checked, items) {
    this.presenter.selectAllForList(checked, items);
  }

  onClickNotification(notif) {
    this.presenter.onClickNotification(notif);
  }

  onMenuAction(notif, action) {
    this.presenter.onMenuAction(notif, action);
  }

  render() {
    const { objects, progress } = this.state;
    if (progress) {
      return <NotificationListLoading />;
    }

    const list = (objects || []).map(normalizeNotification).filter(Boolean);
    const unread = list.filter((n) => !n.isRead);
    const read = list.filter((n) => n.isRead);
    const hasNotifications = list.length > 0;

    if (!hasNotifications) {
      return <NotificationListEmpty />;
    }

    const listProps = {
      selectedIds: this.getSelectedIds(),
      onToggleSelect: this.toggleSelect,
      onSelectAll: this.selectAllForList,
      onBulkMarkRead: this.bulkMarkRead,
      onBulkMarkUnread: this.bulkMarkUnread,
      onBulkDelete: this.bulkDelete,
      onItemClick: this.onClickNotification,
      onMenuAction: this.onMenuAction,
    };

    const panels = {
      all: (
        <NotificationList
          items={list}
          emptyMessage="No notifications"
          {...listProps}
        />
      ),
      unread: (
        <NotificationList
          items={unread}
          emptyMessage="No unread notifications"
          {...listProps}
        />
      ),
      read: (
        <NotificationList
          items={read}
          emptyMessage="No read notifications"
          {...listProps}
        />
      ),
    };

    const tabsWithCounts = getTabsWithCounts({
      listLength: list.length,
      unreadLength: unread.length,
      readLength: read.length,
    });

    return (
      <div className="p-0">
        <TabbedCard
          tabs={tabsWithCounts}
          panels={panels}
          defaultTab="unread"
          cardStyle={{ border: "none", boxShadow: "none" }}
          className="bg-transparent"
        />
      </div>
    );
  }
}

export default withRouter(NotificationListPage);
